import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Enterprise component for eligibility tab
 */
const Enterprise = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="enterprise-component">
      <AccordionV2
        testId="the-enterprise-award"
        className="border-none py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="The Enterprise Award" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 px-6 py-4">
          <p>
            This award is open to all enterprises in Singapore. The criteria for
            the Enterprise Award are categorised into four areas:
          </p>

          <p>
            <strong>Innovation</strong>
          </p>

          <p>
            The success of the company in innovation of either products,
            services or new markets. Particular attention will be focussed on
            the company&apos;s penetration of overseas markets drawing on
            enterprise and expertise of its Singapore base.
          </p>

          <p>
            <strong>Financial Performance/Productivity</strong>
          </p>

          <p>
            The company must have an outstanding and sustained growth in profit.
            The age of a company will be taken into consideration in relation to
            profit track record.
            <br />
            The company must have taken positive steps and made conscious
            efforts towards improving its productivity level.
          </p>

          <p>
            <strong>Company Management</strong>
          </p>

          <p>
            The organisation must display an effective management style and have
            a viable organisational structure. The company must have a track
            record of establishing and maintaining harmonious relations within
            the organisation and set examples for the industry it is in.
          </p>

          <p>
            <strong>Contribution to the Community</strong>
          </p>

          <p>
            The company&apos;s contribution to the community will be considered
            favourably.
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default Enterprise;
